import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_DASHBOARD_NAME = `${REPORT}_SET_DASHBOARD_NAME`;
export const COMMIT_DATA = `${REPORT}_COMMIT_DATA`;
export const REVERT_SLOTS = `${REPORT}_REVERT_SLOTS`;
export const SET_DETAILS = `${REPORT}_SET_DETAILS`;
export const RESET_DETAILS = `${REPORT}_RESET_DETAILS`;
// dnd related
export const ADD_REPORT_TO_ZONE = `${REPORT}_ADD_REPORT_TO_ZONE`;
export const ADD_SLOT_TO_ZONE = `${REPORT}_ADD_SLOT_TO_ZONE`;
export const SWAP_SLOT_WITH_REPORT = `${REPORT}_SWAP_SLOT_WITH_REPORT`;
export const SWAP_SLOT_WITH_SLOT = `${REPORT}_SWAP_SLOT_WITH_SLOT`;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/flow/actionTypes.js